module.exports = __webpack_public_path__ + "img/tv_cultura3.c0f00b27.jpg";